var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.75C7.5 25.125 8.625 26.25 10 26.25H20C21.375 26.25 22.5 25.125 22.5 23.75V11.25C22.5 9.875 21.375 8.75 20 8.75H10C8.625 8.75 7.5 9.875 7.5 11.25V23.75ZM22.5 5H19.375L18.4875 4.1125C18.2625 3.8875 17.9375 3.75 17.6125 3.75H12.3875C12.0625 3.75 11.7375 3.8875 11.5125 4.1125L10.625 5H7.5C6.8125 5 6.25 5.5625 6.25 6.25C6.25 6.9375 6.8125 7.5 7.5 7.5H22.5C23.1875 7.5 23.75 6.9375 23.75 6.25C23.75 5.5625 23.1875 5 22.5 5Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.27f2aada3c89542a15bd532867774ee9.svg";
export { ForwardRef as ReactComponent };